import { c as _c } from "react/compiler-runtime";
import { useSignedCookies } from "@/hooks/assessment/remote/useSignedCookies";
import { useSignedCookieEnabled } from "./signedCookieFlag";

/**
 * tmp_enable_signed_cookie flag が有効な間、全ページで CloudFront signed cookie を維持する。
 * AdminLayout / Remote 画面は個別にも useSignedCookies を呼んでいるが、flag による
 * 画像取得経路の移行に備えてアプリ全体で cookie を整える。
 */
export const SignedCookieGate = () => {
  const $ = _c(2);
  const enabled = useSignedCookieEnabled();
  let t0;
  if ($[0] !== enabled) {
    t0 = enabled ? <GlobalSignedCookies /> : null;
    $[0] = enabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const GlobalSignedCookies = () => {
  useSignedCookies();
  return null;
};